import { formatPrice } from '@lib/formatPrice'
import React, { FC } from 'react'
import * as S from './elements'
import { LoadingBar } from '@gassan-ui'

type Props = {
  price?: number
  discountPrice?: number
  isLoading?: boolean
}

const PriceOnlyVariant: FC<Props> = ({ price, discountPrice, isLoading }) => {
  return (
    <S.StaticPriceContainer>
      {isLoading ? (
        <LoadingBar display={['block', 'none']} mb=".25rem" width="50%" />
      ) : (
        <>
          {discountPrice ? (
            <>
              <S.Price>{formatPrice(discountPrice)}</S.Price>
              <S.Discount color="shades.500" fontStyle="strike-trough">
                {formatPrice(price)}
              </S.Discount>
            </>
          ) : (
            <S.Price>{formatPrice(price)}</S.Price>
          )}
        </>
      )}
    </S.StaticPriceContainer>
  )
}

export default PriceOnlyVariant
